import { forwardRef } from 'react';
import { motion } from 'framer-motion';
import { Box } from '@mui/material';

const BoxRef = forwardRef((props, ref) => (
  <Box ref={ref} sx={{ display: 'flex', flex: 1, width: '100%', justifyContent: 'center', zIndex: "5" }} >{props.children}</Box>
))

const AnimatedBox = motion(BoxRef, { forwardMotionProps: true })

const moduleAnimation = {
  initial: { opacity: 0 },
  animate: {
    opacity: 1,
    transition: {
      duration: 0.5
    }
  },
  exit: { opacity: 0 },
}

const AnimatedModule = (props) => {

  return <AnimatedBox variants={moduleAnimation} initial='initial' animate='animate' exit='exit' {...props} />
}

export default AnimatedModule